const routes = {
  getBuyerIds: 'buyerIds',
  getBuyerIdHistoryLogs: 'buyerIds/logs',
  createBuyerId: 'buyerIds/add',
  updateBuyerId: 'buyerIds/update',
  deleteBuyerId: 'buyerIds/delete',
  sendOtpForPasswordVerification: 'buyerIds/send-otp',
  verifyOtp: 'buyerIds/verify-otp-and-reveal',
  createBusinessLocation:'system/business/locations/add',
  updateBusinessLocation:'system/business/locations/update',
  createOrganization: 'organizations/create',
  getOrganizationData: 'organizations',
  updateOrganization: 'organizations/update',
  sendOrgOtpForPasswordVerification:  'organizations/send-otp',
  verifyOrgOTP:'organizations/verify-otp-and-reveal',
  getBelongsTo: 'buyerIds/buyer-belong-to',

};

export default routes